import React from 'react';
import { Button } from './button.tsx';

interface PaginationProps {
  currentPage: number;
  totalPages: number;
  totalItems: number; // Added totalItems prop
  onPageChange: (page: number) => void;
  disabled: boolean;
}

const Pagination: React.FC<PaginationProps> = ({
  currentPage,
  totalPages,
  totalItems, // Destructure totalItems
  onPageChange,
  disabled,
}) => {
  return (
    <div className="flex items-center justify-between p-4">
      <Button
        variant="outline"
        size="sm"
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage === 1 || disabled}
      >
        Previous
      </Button>
      <span className="text-sm text-muted-foreground">
        Page {currentPage} of {totalPages} ({totalItems} items) {/* Display totalItems */}
      </span>
      <Button
        variant="outline"
        size="sm"
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage === totalPages || disabled}
      >
        Next
      </Button>
    </div>
  );
};

export default Pagination;